// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"RedButton_landingContainer__47RJm","btn":"RedButton_btn__TyTg8"};